import { PropsWithChildren } from 'react';

import { FieldWrapper } from '../field-wrapper';

export function DistanceAdornment({ children }: PropsWithChildren<unknown>) {
  return (
    <FieldWrapper>
      {children}
      <FieldWrapper.EndAdornment>
        <span className="text-secondary text-sm">km</span>
      </FieldWrapper.EndAdornment>
    </FieldWrapper>
  );
}
